import '../scss/ifapme_liege_theme.scss';

import dropdown from './modules/dropdown';
import responsive from './modules/responsive';
import slider from './modules/slider';
import leaflet from './modules/leaflet';
import sticky from './modules/sticky';
import expand from './modules/expand';
import accordion from './modules/accordion';
import scrollToTop from './modules/scrollToTop';
import cart from './modules/cart';
import {ajaxProgressThrobber} from './modules/themes';

(($, Drupal) => {
  Drupal.theme.ajaxProgressThrobber = ajaxProgressThrobber;

  Drupal.behaviors.mainBehavior = {
    attach: function(context, settings) {
      jQuery('body', context).each(() => {
        responsive.waiAria.init();
      });
    }
  };

  Drupal.behaviors.headerBehavior = {
    attach: (context, settings) => {
      jQuery('.header--menu', context).each((index, elementHtmlTag) => {
        dropdown.init(elementHtmlTag);
      });

      if(context.classList && context.classList.contains('header--account')){
        dropdown.init(context,'button');
      }
      else
      {
        jQuery(context).find('.header--account').each((index, elementHtmlTag) => {
          dropdown.init(elementHtmlTag,'button');
        });
      }

      const searchicon = jQuery('header .search-icon');
      if(searchicon.length > 0){
        searchicon.once('search-bar-header').on('click',function(e){
          jQuery('header .search-bar').toggle();
          jQuery('header .search-icon i').toggleClass('icon-search');
          jQuery('header .search-icon i').toggleClass('icon-close');

          e.preventDefault();
        });
      }

      jQuery('.header--menu-mobile-button', context).click(function(){
        jQuery('.region-menu-mobile').toggle();
        jQuery('.header--menu-mobile-button').toggleClass('close').toggleClass('opened');
      });

      jQuery('.header--mobile', context).each((index, elementHtmlTag) => {
        sticky.menuHeader(elementHtmlTag);
      });

      jQuery('.header--part1', context).each((index, elementHtmlTag) => {
        sticky.menuHeader(elementHtmlTag);
      });
    }
  };

  Drupal.behaviors.footerBehavior = {
    attach: (context, settings) => {
      jQuery('.footer--map__wrapper', context).each((index, elementHtmlTag) => {
        leaflet.footerMap();
      });

      jQuery('.footer--map__wrapper', context).each((index, elementHtmlTag) => {
        slider.slideCenterFooter(elementHtmlTag);
      });

      jQuery('.footer--scroll-to-top', context).each((index, elementHtmlTag) => {
        sticky.menuHeader(elementHtmlTag);
      });

      jQuery('.footer--scroll-to-top a', context).each((index, elementHtmlTag) => {
        scrollToTop.init(elementHtmlTag);
      });
    }
  };

  Drupal.behaviors.hpBehavior = {
    attach: (context, settings) => {
      jQuery('.hp--slider', context).each((index, elementHtmlTag) => {
        slider.slideHpHeader(elementHtmlTag);
      });

      jQuery('.hp--view-domains', context).each((index, elementHtmlTag) => {
        expand.init(elementHtmlTag);
      });

      jQuery('.hp--view-news', context).each((index, elementHtmlTag) => {
        slider.slideHpNews(elementHtmlTag);
      });

      jQuery('.hp--trust', context).each((index, elementHtmlTag) => {
        slider.slideHpTrust(elementHtmlTag);
      });
    }
  };

  Drupal.behaviors.linkedContentBehavior = {
    attach: (context, settings) => {
      jQuery('.view--linked-discover-paragraph', context).each((index, elementHtmlTag) => {
        slider.slideDiscoverParagraph(elementHtmlTag);
      });

      /* no context because it is too long */
      jQuery('.view--linked-new:not(.slider-set)').each((index, elementHtmlTag) => {
        jQuery(elementHtmlTag).addClass('slider-set');
        slider.slideHpNews(elementHtmlTag);
      });
    }
  };

  Drupal.behaviors.productBehavior = {
    attach: (context, settings) => {
      jQuery('.product--accordion', context).each((index, elementHtmlTag) => {
        accordion.init(elementHtmlTag);
      });
      jQuery('.product-variation--accordion', context).each((index, elementHtmlTag) => {
        accordion.init(elementHtmlTag);
      });
      jQuery('.footer--accordion', context).each((index, elementHtmlTag) => {
        accordion.init(elementHtmlTag);
      });
    }
  };

  Drupal.behaviors.cartBehavior = {
    attach: (context, settings) => {
      jQuery('.cart-block--link__expand', context).each((index, elementHtmlTag) => {
        cart.init(elementHtmlTag);
      });
    }
  };
})($, Drupal);
